import { Action } from '@ngrx/store';

export const enum MEDIA_ACTIONS {
  PLAY_VIDEO = '[Media] Play Video',
  OPEN_IMAGE = '[Media] Open Image'
}

export class PlayVideoAction implements Action {
  readonly type = MEDIA_ACTIONS.PLAY_VIDEO;

  constructor(public payload: string) {}
}

export class OpenImageAction implements Action {
  readonly type = MEDIA_ACTIONS.OPEN_IMAGE;

  constructor(public payload: string) {}
}

export type MediaAction = PlayVideoAction | OpenImageAction;
